<template>
    <div class='center'>
        很抱歉 404 没有找到相关页面~
    </div>
</template>

<script>
    export default {
        name: "error"
    }
</script>

<style scoped>
    .center{
        width:100%;
        height:400px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
